<template>
  <div class="different-container">
    <main class="hero">
      <h5>Tenha maior controlo das suas finanças.</h5>
      <p>
        Adiciona contas, regista entradas e saídas de dinheiro, visualiza relatórios e
        toma decisões acertadas. Realiza tudo isso por meio de uma aplicacao simples, rápida e
        intuitiva.
      </p>
      <div class="image-container">
        <picture>
          <source srcset="@/assets/img/appShowcase.webp" type="image/webp" />
          <source srcset="@/assets/img/appShowcase.png" type="image/png" />
          <img src="@/assets/img/appShowcase.png" alt="apresentacao da aplicacao" />
        </picture>
      </div>
      <p>Queres ver mais?</p>
      <AppButton @click.native="goToRoute" id="/registar-se" text="Regista-te" />
    </main>
    <ul class="section-0">
      <li>
        <AppIcon iconName="hb1" />
        <span>Adicione um número ilimitado de contas para o rastreio dos gastos</span>
      </li>
      <li>
        <AppIcon iconName="hb2" />
        <span>Visualize de forma eficiente e simplificada relatórios das entradas e saídas</span>
      </li>
      <li>
        <AppIcon iconName="hb3" />
        <span>Desfrute de backups para a nuvem de forma automática</span>
      </li>
      <li>
        <AppIcon iconName="hb4" />
        <span>Sincronização dos dados entre os teus dispositivos</span>
      </li>
      <li>
        <AppIcon iconName="hb5" />
        <span>Customize o teu perfil e as tuas contas</span>
      </li>
    </ul>
    <section class="section-1">
      <p>
        Para auxiliar-te a melhor gerir o teu dinheiro tens aqui algumas muitas dicas de poupança e
        gestão financeira.
      </p>
      <AppButton @click.native="goToRoute" id="/dicas-de-gestao" text="Ver dicas" />
    </section>
    <TheFooter class="footer" />
  </div>
</template>

<script>
import AppButton from "../components/AppButton.vue";
import AppIcon from "../components/AppIcon.vue";
import TheFooter from "../components/TheFooter.vue";

export default {
  name: "TheHome",
  components: {
    TheFooter,
    AppButton,
    AppIcon
  },
  computed: {
    checkInstallationStatus() {
      const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
      if (document.referrer.startsWith("android-app://")) {
        return "twa";
      }
      if (window.navigator.standalone || isStandalone) {
        return "standalone";
      }
      return "browser";
    }
  },
  methods: {
    goToRoute(e) {
      const nextRoute = e.srcElement.id;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
    }
  }
};
</script>

<style scoped>
.different-container {
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  flex: 0 0 100%;
}

.hero {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  height: fit-content;
  flex: 0 0 100%;
  margin: 1.6rem 1rem;
}

.hero h5 {
  margin-bottom: 0.6rem;
}

.image-container img {
  max-width: 100%;
}

.image-container {
  width: 18.125rem;
  margin: 1.6rem auto 1.2rem auto;
  filter: drop-shadow(0 0 0.4rem rgba(0, 0, 0, 0.3));
}

.hero p:last-of-type {
  margin-bottom: 1.6rem;
  text-align: center;
}

.hero button {
  margin: 0 auto -0.4rem auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.section-0 {
  flex: 0 0 100%;
  margin: 1.6rem 1rem;
}

.section-0 li {
  padding: 1.2rem 1.4rem;
  background-color: var(--color-white);
  border-radius: 5px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

.section-0 li:last-of-type {
  margin-bottom: 0;
}

.section-0 li span {
  color: var(--color-tertiary);
}

.section-0 li svg {
  margin-right: 8px;
}

.section-1 {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  margin: 0.6rem 1rem;
}

.section-1 button {
  margin: 1.6rem auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.footer {
  flex: 0 0 100%;
  margin-top: auto;
}

p {
  color: var(--color-tertiary);
}
</style>
